import faker from 'faker'
import moment from 'moment'
import hres82eLabels from 'assets/labels/hres82e'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres82eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 500
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        roomno: (faker.lorem.word()).substring(0, 8),
        desc_roomno: faker.lorem.word(),
        staappr: 'B',
        desc_staappr: faker.lorem.word(),
        timperiod: moment().format('hh:mm') + ' - ' + moment().format('hh:mm'),
        codempid: faker.name.findName(),
        desc_codempid: faker.name.findName(),
        codcomp: faker.lorem.word(),
        desc_codcomp: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  roomDetail () {
    let mockRoomDetail = {
      roomno: (faker.lorem.word()).substring(0, 8),
      desc_roomno: faker.lorem.word(),
      status: 'A',
      desc_status: faker.lorem.word(),
      floor: '9',
      building: faker.lorem.word(),
      qtypers: '99',
      accessori: faker.lorem.word(),
      remark: faker.lorem.word(),
      codrespon: (faker.lorem.word()).substring(0, 8),
      desc_codrespon: faker.lorem.word()
    }

    return mockRoomDetail
  },
  calendar () {
    let mockRows = []
    const mockTotal = 31
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereserv: Math.floor(Math.random() * 31) + '/08/2017'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  calendarDetail () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereq: moment().format('DD/MM/YYYY'),
        seqno: Math.floor(Math.random() * 100) + 1,
        desc_codempid: faker.lorem.word(),
        timperiod: '10:00 - 11:00',
        desc_staappr: faker.lorem.word(),
        staappr: faker.lorem.word(),
        desc_codappr: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  reserveCreate () {
    let mockReserveCreate = {
      dtereq: moment().format('DD/MM/YYYY'),
      seqno: Math.floor(Math.random() * 100) + 1,
      timstrt: '',
      timend: '',
      staappr: 'B',
      desc_staappr: 'จอง',
      object: '',
      remark: '',
      qtypers: '',
      codempid: (faker.lorem.word()).substring(0, 8),
      desc_codempid: faker.lorem.word(),
      codappr: '',
      desc_codappr: ''
    }

    return mockReserveCreate
  },
  reserveDetail () {
    let mockReserveDetail = {
      dtereq: moment().format('DD/MM/YYYY'),
      seqno: Math.floor(Math.random() * 100) + 1,
      timstrt: '16:00',
      timend: '18:00',
      staappr: 'B',
      desc_staappr: 'จอง',
      object: faker.lorem.word(),
      remark: faker.lorem.word(),
      qtypers: Math.floor(Math.random() * 100),
      codempid: (faker.lorem.word()).substring(0, 8),
      desc_codempid: faker.lorem.word(),
      codappr: (faker.lorem.word()).substring(0, 8),
      desc_codappr: faker.lorem.word()
    }

    return mockReserveDetail
  },
  reserveCancel () {
    return labels.mockPostMessage
  },
  reserveSave () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres82e/mocker.js